




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BPCTable, BPCTableField } from '@shared/interfaces/bpc-table-interface';
import { Booking } from '@bookings/interfaces/booking';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Table from '@shared/components/tables/table.vue';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { mixins } from 'vue-class-component';

import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import DisplayFieldArray from '@shared/components/displays/display-field-array/display-field-array.vue';
import DisplayFieldDays from '@shared/components/displays/display-field-days/display-field-days.vue';
import DisplayFieldTimeRange from '@shared/components/displays/display-field-time-range/display-field-time-range.vue';
import DisplayFieldAmount from '@shared/components/displays/display-field-amount/display-field-amount.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayFieldDate from '@shared/components/displays/display-field-date/display-field-date.vue';
import DisplayField from '@shared/components/displays/display-field/display-field.vue';
import ToolsHelper from '@core/services/tools.helper';

const defaultTableFields: BPCTableField[] = [
  {
    key: 'date',
    headerLabel: `global.booking_event.date`,
    order: 0,
  },
  {
    key: 'time_range',
    headerLabel: `global.booking_event.time_range`,
    order: 1,
  },
  {
    key: 'resources',
    headerLabel: `global.booking_event.resource`,
    order: 3,
  },
  {
    key: 'eventPrice',
    headerLabel: `global.booking_event.price`,
    order: 4,
  },
  {
    key: 'action',
    headerLabel: 'global.booking_event.action',
    order: 5,
  },
];

@Component({
  name: 'bc-public-oragnization-booking-form',
  components: {
    'bpc-display-field': DisplayField,
    'bc-multi-select': MultiSelect,
    'bpc-drawer-modal': DrawerModal,
    'bpc-entity-select': EntitySelect,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-table': Table,
    'bpc-display-code': DisplayFieldCode,
    'bpc-display-array': DisplayFieldArray,
    'bpc-display-days': DisplayFieldDays,
    'bpc-display-time-range': DisplayFieldTimeRange,
    'bpc-display-date': DisplayFieldDate,
    'bpc-display-amount': DisplayFieldAmount,
    'bpc-display-badge': DisplayFieldBadge,
  },
})
export default class PublicOrganizationBookingForm extends mixins(Vue) implements BPCTable {
  // PROPS
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly isInput: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop({ type: Boolean, default: false }) readonly withUrlParams: boolean;
  @Prop({ type: String, default: 'desc' }) readonly BookingEventOrganizationTableInput: string;
  @Prop({ type: Array, default: () => [] }) readonly value: BookingEvent[];
  @Prop({
    default() {
      return defaultTableFields;
    },
  })
  readonly tableFields: BPCTableField[];
  @Prop({ type: Boolean, default: true }) readonly showActions: boolean;

  // DATA
  loading: boolean = false;
  booking: Booking = null;

  // COMPUTED
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get model(): BookingEvent[] {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  get totalAmount() {
    let total = 0;
    this.model.forEach(item => {
      if (item.action === 'create') {
        total = total + item.eventPrice;
      }
    });
    return ToolsHelper.formatPrice(total);
  }

  get permissionEntityName(): string {
    return 'bookings';
  }

  get fieldsToShow(): object[] {
    return this.tableFields.sort((f1, f2) => f1.order - f2.order);
  }

  get bookingId() {
    return this.booking?.id;
  }

  get displayDateConfig(): object {
    return {
      displayType: 'date',
      key: 'date',
    };
  }
  get displayTimeRangeConfig(): object {
    return {
      date_range: {
        displayType: 'time-range',
      },
    };
  }

  get displayResourceConfig(): object {
    return {
      displayType: 'array',
      fieldPath: 'code',
    };
  }

  get displayBookingPriceConfig(): object {
    return {
      displayType: 'amount',
      withTotalAmount: true,
    };
  }

  get displayStatusConfig(): object {
    return {
      inputType: 'select',
      displayType: 'badge',
      valueToLabel: [
        { value: 'cancelled', label: 'global.fields.status.cancelled.label' },
        { value: 'refused', label: 'global.fields.status.refused.label' },
        { value: 'confirmed', label: 'global.fields.status.confirmed.label' },
        { value: 'requested', label: 'global.fields.status.requested.label' },
        { value: 'draft', label: 'global.fields.status.draft.label' },
      ],
      valueToVariant: [
        { value: 'confirmed', variant: 'success' },
        { value: 'requested', variant: 'success' },
        { value: 'draft', variant: 'success' },
        { value: 'cancelled', variant: 'danger' },
        { value: 'refused', variant: 'danger' },
      ],
      toTranslate: true,
    };
  }

  // METHODS

  //  TODO:

  // LIFECYCLE
}
